import { HttpEvent, HttpHandlerFn, HttpParameterCodec, HttpParams, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";

  export function authInterceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {

    let currentUser = null;

    if( sessionStorage.getItem('user') ){
      currentUser = JSON.parse(sessionStorage.getItem('user') ?? '');
    }

    const params = new HttpParams({ encoder: new CustomEncoder(), fromString: req.params.toString()});
    if (currentUser && currentUser.token && currentUser.token.access_token && !req.url.includes(`/login`)){
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token.access_token}`,
          tracingId: self.crypto.randomUUID(),
          'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
          'Content-Security-Policy': "script-src 'self'",
          'X-Frame-Options': 'DENY',
          'X-Content-Type-Options': 'nosniff',
          'Referrer-Policy': 'strict-origin-when-cross-origin',
          'Permissions-Policy': 'geolocation=(self)',
          'Cross-Origin-Embedder-Policy': 'require-corp',
          'Origin-Opener-Policy': 'same-origin-allow-popups',
          'Cross-Origin-Resource-Policy': 'same-site',
          'X-Permitted-Cross-Domain-Policies': 'none'
        },
      });
    }
    return next(req.clone({ params }));

  }

class CustomEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}
